import { frontendURL } from '../../../../helper/URLHelper';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

import ReportsWrapper from './components/ReportsWrapper.vue';
import Index from './Index.vue';

import AgentReportsIndex from './AgentReportsIndex.vue';
import InboxReportsIndex from './InboxReportsIndex.vue';
import TeamReportsIndex from './TeamReportsIndex.vue';
import LabelReportsIndex from './LabelReportsIndex.vue';

import AgentReportsShow from './AgentReportsShow.vue';
import InboxReportsShow from './InboxReportsShow.vue';
import TeamReportsShow from './TeamReportsShow.vue';
import LabelReportsShow from './LabelReportsShow.vue';

import AgentReports from './AgentReports.vue';
import InboxReports from './InboxReports.vue';
import LabelReports from './LabelReports.vue';
import TeamReports from './TeamReports.vue';

import CsatResponses from './CsatResponses.vue';
import BotReports from './BotReports.vue';
import LiveReports from './LiveReports.vue';
import SLAReports from './SLAReports.vue';

// GK-HUB: ISP Report page imports
import IspMotivos from './isp/IspMotivos.vue';
import IspFcr from './isp/IspFcr.vue';
import IspRecorrencia from './isp/IspRecorrencia.vue';
import IspPainel from './isp/IspPainel.vue';
import IspMonitoramento from './isp/IspMonitoramento.vue';
import IspPausas from './isp/IspPausas.vue'; // GK-HUB: Break report page
import IspQueueMetrics from './isp/IspQueueMetrics.vue'; // GK-HUB: Queue metrics report
import IspAgentRanking from './isp/IspAgentRanking.vue'; // GK-HUB: Agent ranking report
import IspConversas from './isp/IspConversas.vue'; // GK-HUB: Conversations report
import IspCsat from './isp/IspCsat.vue'; // GK-HUB: CSAT ISP report
import IspCampanhas from './isp/IspCampanhas.vue'; // GK-HUB: Campaign analytics report

// GK-HUB: Added manager to standard report permissions (supervisor sees only ISP reports)
const meta = {
  featureFlag: FEATURE_FLAGS.REPORTS,
  permissions: ['administrator', 'manager', 'report_manage'],
};

// GK-HUB: ISP reports accessible by supervisor+ (department-scoped on backend)
// GK-HUB: fullWidth removes max-w-[60rem] from ReportsWrapper for dashboard layouts
const ispMeta = {
  featureFlag: FEATURE_FLAGS.REPORTS,
  permissions: ['administrator', 'manager', 'supervisor', 'report_manage'],
  fullWidth: true,
};

const oldReportRoutes = [
  {
    path: 'agent',
    name: 'agent_reports',
    meta,
    component: AgentReports,
  },
  {
    path: 'inboxes',
    name: 'inbox_reports',
    meta,
    component: InboxReports,
  },
  {
    path: 'label',
    name: 'label_reports',
    meta,
    component: LabelReports,
  },
  {
    path: 'teams',
    name: 'team_reports',
    meta,
    component: TeamReports,
  },
];

// GK-HUB: Added 'manager' to all revised report route permissions
const revisedReportRoutes = [
  {
    path: 'agents_overview',
    name: 'agent_reports_index',
    meta: {
      permissions: ['administrator', 'manager', 'report_manage'],
    },
    component: AgentReportsIndex,
  },
  {
    path: 'agents/:id',
    name: 'agent_reports_show',
    meta: {
      permissions: ['administrator', 'manager', 'report_manage'],
    },
    component: AgentReportsShow,
  },

  {
    path: 'inboxes_overview',
    name: 'inbox_reports_index',
    meta: {
      permissions: ['administrator', 'manager', 'report_manage'],
    },
    component: InboxReportsIndex,
  },
  {
    path: 'inboxes/:id',
    name: 'inbox_reports_show',
    meta: {
      permissions: ['administrator', 'manager', 'report_manage'],
    },
    component: InboxReportsShow,
  },
  {
    path: 'teams_overview',
    name: 'team_reports_index',
    meta: {
      permissions: ['administrator', 'manager', 'report_manage'],
    },
    component: TeamReportsIndex,
  },
  {
    path: 'teams/:id',
    name: 'team_reports_show',
    meta: {
      permissions: ['administrator', 'manager', 'report_manage'],
    },
    component: TeamReportsShow,
  },
  {
    path: 'labels_overview',
    name: 'label_reports_index',
    meta: {
      permissions: ['administrator', 'manager', 'report_manage'],
    },
    component: LabelReportsIndex,
  },
  {
    path: 'labels/:id',
    name: 'label_reports_show',
    meta: {
      permissions: ['administrator', 'manager', 'report_manage'],
    },
    component: LabelReportsShow,
  },
];
// GK-HUB: end revised report route permissions

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: ReportsWrapper,
      children: [
        // GK-HUB: Default redirect to Painel Geral (unified reports landing page)
        {
          path: '',
          redirect: to => {
            return { name: 'isp_painel_reports', params: to.params };
          },
        },
        {
          path: 'overview',
          name: 'account_overview_reports',
          meta,
          component: LiveReports,
        },
        {
          path: 'conversation',
          name: 'conversation_reports',
          meta,
          component: Index,
        },
        ...oldReportRoutes,
        ...revisedReportRoutes,
        {
          path: 'sla',
          name: 'sla_reports',
          meta,
          component: SLAReports,
        },
        {
          path: 'csat',
          name: 'csat_reports',
          meta,
          component: CsatResponses,
        },
        {
          path: 'bot',
          name: 'bot_reports',
          meta,
          component: BotReports,
        },
        // GK-HUB: ISP Report routes (use ispMeta — supervisor+ can access)
        {
          path: 'isp-agent-ranking',
          name: 'isp_agent_ranking_reports',
          meta: ispMeta,
          component: IspAgentRanking,
        },
        {
          path: 'isp-motivos',
          name: 'isp_motivos_reports',
          meta: ispMeta,
          component: IspMotivos,
        },
        {
          path: 'isp-fcr',
          name: 'isp_fcr_reports',
          meta: ispMeta,
          component: IspFcr,
        },
        {
          path: 'isp-recorrencia',
          name: 'isp_recorrencia_reports',
          meta: ispMeta,
          component: IspRecorrencia,
        },
        {
          path: 'isp-painel',
          name: 'isp_painel_reports',
          meta: ispMeta,
          component: IspPainel,
        },
        {
          path: 'isp-monitoramento',
          name: 'isp_monitoramento_reports',
          meta: ispMeta,
          component: IspMonitoramento,
        },
        {
          path: 'isp-pausas',
          name: 'isp_pausas_reports',
          meta: ispMeta,
          component: IspPausas,
        },
        {
          path: 'isp-fila',
          name: 'isp_queue_metrics_reports',
          meta: ispMeta,
          component: IspQueueMetrics,
        },
        {
          path: 'isp-conversas',
          name: 'isp_conversas_reports',
          meta: ispMeta,
          component: IspConversas,
        },
        {
          path: 'isp-csat',
          name: 'isp_csat_reports',
          meta: ispMeta,
          component: IspCsat,
        },
        {
          path: 'isp-campanhas',
          name: 'isp_campanhas_reports',
          meta: ispMeta,
          component: IspCampanhas,
        },
        // GK-HUB: end ISP routes
      ],
    },
  ],
};
